var _use, _symbol, _defs, _style;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMedium(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "medium-icon",
    fill: "current",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 66 54",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#A",
    x: 0.5,
    y: 0.5
  })), _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    id: "A",
    overflow: "visible"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.158 47.432L64 52.107v.155H39.44v-.155l4.93-4.675c.526-.433.778-1.12.657-1.795V15.752c0-1.263 0-2.97.22-4.43L28.68 52.86h-.197L11.328 14.644l-.723-1.662V38.03a8.79 8.79 0 0 0 .811 4.896l6.902 9.172v.155H0v-.155l6.902-9.194c.73-1.512 1-3.204.8-4.874V10.346c.112-1.364-.295-2.72-1.14-3.788L1.687.155V0h17.528l14.68 32.368L46.822 0h17.156v.155l-4.82 5.428c-.578.427-.866 1.148-.745 1.86v38.194a1.78 1.78 0 0 0 .745 1.795z",
    stroke: "none",
    fill: "current",
    fillRule: "nonzero"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n        #medium-icon {\n  \t\t\ttransform: scale(0.85);\n        }\n")));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedium);
export default __webpack_public_path__ + "static/media/medium.c6bd4dde.svg";
export { ForwardRef as ReactComponent };